import { StatCardResultDto } from "api/interfaces/planInterface.interface";
import { formatNumber } from "utils/functions";
import ChannelBreakdownContent, {
  useChannelBreakdown,
} from "./ChannelBreakdownContent";
import StorageBreakdownContent, {
  useStorageBreakdown,
} from "./StorageBreakdownContent";
import * as s from "./BreakdownStyled";

export const ESTIMATE_COST_BREAKDOWN_TITLE = "Calculation breakdown";
export const ESTIMATE_COST_BREAKDOWN_SUBTITLE =
  "Step-by-step math behind your estimated monthly cost, using this month's live usage.";

type Props = {
  summary: StatCardResultDto;
};

export default function EstimateCostBreakdownContent({
  summary,
}: Props): JSX.Element {
  const { channelCost } = useChannelBreakdown(summary);
  const { storageCost } = useStorageBreakdown(summary);

  const estimatedTotal = channelCost + storageCost;

  return (
    <s.Wrapper>
      <ChannelBreakdownContent
        summary={summary}
        sectionTitle="1. Channel usage"
      />
      <StorageBreakdownContent
        summary={summary}
        sectionTitle="2. Storage usage"
      />

      <s.Section>
        <div className="section-title">3. Estimated monthly total</div>
      </s.Section>
      <s.Box>
        <s.Row>
          <span className="label">Channels</span>
          <span className="value">${formatNumber(channelCost)}</span>
        </s.Row>
        <s.Row>
          <span className="label">Storage</span>
          <span className="value">${formatNumber(storageCost)}</span>
        </s.Row>
        <s.Divider />
        <s.Row className="highlight">
          <span className="label">Estimated total</span>
          <span className="value">${formatNumber(estimatedTotal)}</span>
        </s.Row>
      </s.Box>

      <s.Footnote>
        Each component is rounded to 2 decimal places before being summed. The
        final invoice is issued at the end of the month based on actual usage.
      </s.Footnote>
    </s.Wrapper>
  );
}
